// extracted by css-extract-rspack-plugin
export default {"gate":"gate-O8kuun"};